
export function getUpdatedSearchParam(updates, location) {
  const params = new URLSearchParams(location.search);
  Object.keys(updates).forEach((key) => {
    params.set(key, updates[key]);
  });
  return params.toString();
};
